export default class Product {
	/** @type {int} */
	id = 0;
	name = '';

	constructor(p) {
		this.id = parseInt(p.id);
		this.name = p.name;
	}
}